import { Pipe, PipeTransform } from '@angular/core';
import { StringUtils } from '../utils/string';

@Pipe({ name: 'humanizeTextCode', pure: true })
export class HumanizeTextCodePipe implements PipeTransform {
  public transform(value: string): string {
    return StringUtils.humanizeTextCode(value);
  }
}
